/**
 *
 * @param {Object} param0
 * @param {Number} param0.pct 0.25 | 0.5 | 0.75 | 1
 * @param {Number} param0.price
 * @param {Number} param0.value lot | buying power
 * @param {Boolean} param0.isLot true | false
 * @returns {number}
 */
const stockCalculateLot = ({ pct, price, value = 0, isLot = false }) =>
  isLot ? Math.floor(value * parseFloat(pct)) : Math.floor((value * parseFloat(pct)) / price / 100);

export default stockCalculateLot;
